import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = () => ['saleAddress'];

const fetchSale = async () => {
  const res = await request.get(
    `/FlatsGrid/sale_address_life_cycle`,
    null,
    'Не удалось загрузить стадии продажи'
  );
  return res;
};

const useSaleQuery = (options) => useQuery(key(), fetchSale, options);

export { useSaleQuery };
